import { createEvent, Store } from 'effector';
import { TAppNotification, TAppNotificationParams } from '@src/providers/App/models';
import { $notificationsStore as globalNotificationsStore } from '@centra/ui-global-context';

export const addNotification = createEvent<TAppNotificationParams>();
export const removeNotification = createEvent<number>();

export const $notificationsStore = globalNotificationsStore as unknown as Store<TAppNotification[]>;

$notificationsStore
  .on(addNotification, (notificationList, newNotification) => [
    ...notificationList,
    { ...newNotification, id: notificationList[notificationList.length - 1]?.id + 1 || 0 },
  ])
  .on(removeNotification, (notificationList, id) => notificationList.filter((nf) => nf.id !== id));
